import React from 'react';

function ShowDetail() {
    return (
        <div className="loader center" style={{textAlign: "center"}}>
            <i style={{ fontSize: "25px"}} className="fa fa-cog fa-spin" />
        </div>
    );
}

export default ShowDetail;